import {
  initializeClientsThunk,
  fetchAllClientsAndProjectsThunk,
} from "Actions";
import Loading from "Components/Loading/Loading";
import {
  useClientIdFromUrl,
  useClientSelector,
  useProjectIdFromUrl,
  useProjectSelector,
} from "Hooks";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

export const withClientorProjects = <T extends object>(
  Comp: React.ComponentType<T>
) => {
  const ReturnedComp: React.FC<T> = (props) => {
    const clientId = useClientIdFromUrl();
    const projectId = useProjectIdFromUrl();
    const dispatch = useDispatch();
    const client = useClientSelector();
    const project = useProjectSelector();
    useEffect(() => {
      if (clientId && (!client || client.id !== Number(clientId))) {
        dispatch(initializeClientsThunk());
      }
      if (
        clientId &&
        projectId &&
        (!client ||
          client.id !== Number(clientId) ||
          !project ||
          project.id !== Number(projectId))
      ) {
        dispatch(
          fetchAllClientsAndProjectsThunk({
            clientId: Number(clientId),
            projectId: Number(projectId),
          })
        );
      }
    }, [clientId, projectId, dispatch, client, project]);
    if (project && client) {
      return <Comp {...props} />;
    }
    if (!projectId && client) {
      return <Comp {...props} />;
    }
    if (!clientId && !projectId) {
      return <Comp {...props} />;
    }

    return <Loading fullHeight />;
  };
  return ReturnedComp;
};
